<template>
  <div v-title data-title="收货地址">
    <section>
      <div v-if="headaddress.ID!= undefined" class="address-main" @click="goback(headaddress.ID)">
        <p class="user-name">
          {{headaddress.ReceiverName}}
          <small>{{headaddress.ReceiverPhone}}</small>
        </p>
        <a href="javascript:void(0)" class="add-edit" @click.stop="toedit(headaddress.ID)">
          <img src="../../assets/img/edit.png" />
        </a>
        <div class="add-list">
          <p class="add-con">
            <span v-if="headaddress.IsDefaultAddress==1" class="default">默认</span>
            {{headaddress.Province}}{{headaddress.City}}{{headaddress.Area}}{{headaddress.Address}}
          </p>
          <a
            href="javascript:void(0)"
            class="add-del"
            style="top:5px"
            @click.stop="del(headaddress.ID)"
          >
            <img src="../../assets/img/del.png" />
          </a>
        </div>
      </div>

      <div class="add-panel mt10">
        <div
          class="add-list"
          @click="goback(item.ID)"
          v-for="(item,$index) in this.formset"
          :key="$index"
        >
          <p class="user-name">
            {{item.ReceiverName}}
            <small>{{item.ReceiverPhone}}</small>
          </p>
          <a href="javascript:void(0)" class="add-edit" @click.stop="toedit(item.ID)">
            <img src="../../assets/img/edit.png" />
          </a>
          <p class="add-con">
            <span v-if="item.IsDefaultAddress==1" class="default">默认</span>
            {{item.Province}}{{item.City}}{{item.Area}}{{item.Address}}
          </p>

          <a href="javascript:void(0)" class="add-del" @click.stop="del(item.ID)">
            <img src="../../assets/img/del.png" />
          </a>
        </div>
      </div>
      <button class="address-add" @click="toadd()">+新增收货地址</button>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import { Dialog } from "we-vue";

export default {
  name: "deliveryaddress",
  data: function() {
    return {
      formset: [],
      pagetype: "",
      headaddress: {}
    };
  },
  created: function() {
    var url = window.location.href;
    var type = this.$route.query.type;
    if (type != null && type != undefined && type != "") {
      this.pagetype = type;
    }
    this.getdeliveryaddresses();
  },
  methods: {
    toadd: function() {
      this.$router.push("/page/deliveryaddressadd");
    },
    goback: function(id) {
      if (this.pagetype == "chooseaddress") {
        localStorage.setItem("chooseaddress", id);
        window.history.go(-1);
      }
    },
    toedit: function(id) {
      this.$router.push({
        path: "/page/deliveryaddressedit",
        query: {
          id: id
        }
      });
    },
    del: function(id) {
      Dialog.confirm({
        title: "",
        message: "确认删除改地址？",
        skin: "ios",
        showCancelButton: true
      }).then(() => {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/tbdeliveryaddress/del", {
            params: { id: id }
          })
          .then(
            function(d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                Toast.success("删除成功");
                this.getdeliveryaddresses();
              } else {
                Toast.fail(rep.Message);
              }
            },
            function(d) {
              console.log(d);
            }
          );
      });
    },

    getdeliveryaddresses: function() {
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "api/tbdeliveryaddress/gettbdeliveryaddresses",
          {
            params: {}
          }
        )
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = [];
              this.headaddress = {};
              for (var i = 0; i < rep.Data.length; i++) {
                if (rep.Data[i].IsDefaultAddress == 1) {
                  this.headaddress = rep.Data[i];
                } else {
                  this.formset.push(rep.Data[i]);
                }
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>

<style>
.deliveryaddress {
  height: 80px;
  border-radius: 3%;
  border: 1px solid #999;
  width: 90;
  margin-top: 10px;
}
.qgg {
  display: block;
  border: none;
  font-size: 1.6rem;
  background: #ff7135;
  color: #fff;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bolder;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/deliveryaddress/deliveryaddress.vue